var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconComputerTower = function SvgIconComputerTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 18 22H6a1.75 1.75 0 0 1-1.75-1.75V3.75C4.25 2.784 5.034 2 6 2zM6.25 20h11.5V4H6.25zM12 15.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m3-5.875a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2zm0-3.75a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2z"
  })));
};
export default SvgIconComputerTower;